import { Plus, X } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Select } from '@/components/ui/Select';

interface ActivityHeaderProps {
  activeSectionUuid: string;
  classSelectOptions: { value: string; label: string }[];
  onClassChange: (value: string) => void;
  isFormOpen: boolean;
  onToggleForm: () => void;
}

export function ActivityHeader({
  activeSectionUuid,
  classSelectOptions,
  onClassChange,
  isFormOpen,
  onToggleForm,
}: ActivityHeaderProps) {
  return (
    <div id="activity-page-header" className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 scroll-mt-20">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold text-ink tracking-tight">
          Class Activities
        </h1>
        <p className="text-xs sm:text-sm text-ink-3 font-medium mt-1">
          Plan, organize and track all learning activities for your class.
        </p>
      </div>

      {/* Right Controls: Active Class dropdown + Create Activity Button */}
      <div className="flex flex-wrap items-center gap-3">
        {/* Active Class dropdown */}
        <div className="min-w-[200px] sm:min-w-[240px]">
          <Select
            label="Active Class"
            options={classSelectOptions}
            value={activeSectionUuid}
            onChange={(event) => onClassChange(event.target.value)}
            className="h-9 text-sm font-semibold"
          />
        </div>

        {/* Create Activity Button */}
        <div className="self-end">
          <Button
            variant={isFormOpen ? 'secondary' : 'primary'}
            size="sm"
            leftIcon={isFormOpen ? <X className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
            onClick={onToggleForm}
            className="h-9 px-4 text-[14px] font-bold bg-indigo-600 hover:bg-indigo-700 text-white rounded-[10px] shadow-xs"
          >
            {isFormOpen ? 'Close' : 'Create Activity'}
          </Button>
        </div>
      </div>
    </div>
  );
}
